import React, { useEffect, useState } from "react";
import { Button, Modal, Checkbox } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  updateSubContractor,
} from "../../webServices/Apis";
import { message } from "antd";
import Loader from "../Loader/Loader";

const EditSubContracter = ({
  showEditSubContracter,
  setShowEditSubContracter,
  selectedSubContracter,
  action,
  setAction,

}) => {
  const [open, setOpen] = useState(showEditSubContracter);
  const [loading, setLoading] = useState(false);
  const [profileImage, setProfileImage] = useState(null); // State to manage profile image
  const [isHstApplied, setIsHstApplied] = useState(selectedSubContracter.applyHst || false);
  const [activeValue, setActiveValue] = useState('')


  const closeEditModal = () => {
    setOpen(false);
    setShowEditSubContracter(false);
  };


  const formik = useFormik({
    initialValues: {
      firstName: selectedSubContracter.firstName,
      lastName: selectedSubContracter.lastName,
      email: selectedSubContracter.email,
      
      phone: selectedSubContracter.phone,
      emerPhone: selectedSubContracter.emergencyPhone ?? "",
      street: selectedSubContracter.street,
      city: selectedSubContracter.city,
      prov: selectedSubContracter.prov,
      code: selectedSubContracter.code,
      homePhone: selectedSubContracter.homePhone ?? "",
      ins: selectedSubContracter.ins,
      bus: selectedSubContracter.bus,
      active: selectedSubContracter.active,
      hst: selectedSubContracter.hst,
      applyHst: selectedSubContracter.applyHst,
      hstRate: selectedSubContracter.hstRate ,
      comment: selectedSubContracter.comment ?? "",

      companyName: selectedSubContracter.companyName ?? "",

      status: selectedSubContracter.active ? "active" : "inactive",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required").max(30, "Fist name should not be more than 30 characters").trim("First name should not have spaces").matches(/^[a-zA-Z]+$/, "First name should contains only letters also not spaces"),
      lastName: Yup.string().required("Last name is required").max(30, "Last name should not be more than 30 characters").trim("Last name should not have spaces").matches(/^[a-zA-Z]+$/, "Last name should contains only letters also not spaces"),
       phone: Yup.string()
        .required("Phone number is required")
        .matches(/^(?!-)(?!.*--)(\d-?){5,14}\d$/, "Phone number must be between 6 and 15 digits"),
      homePhone: Yup.string().matches(/^\d{6,15}$/, "Home phone number must be between 6 and 15 digits"),
      emerPhone: Yup.string().matches(/^\d{6,15}$/, "Emergency phone number must be between 6 and 15 digits"),
      comment: Yup.string().max(200, "Comment cannot be more than 200 characters")
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      
      setLoading(true)
      try {

        if (values.applyHst){
          if(values.hstRate === null || values.hstRate === "" || values.hstRate === 0){
            message.error("HST rate can not be zero if you applied your hst")
            return;
          }
        }

        if(!values.applyHst){
          values.hstRate = 0.0;
        }


        const response = await updateSubContractor(
          selectedSubContracter.id,
          {
            ...values,
            active: values.status === 'active' ? true : false
          }
        );

        if (response.data.success) {
          message.success(response?.data?.message);
          resetForm();
          setOpen(false);
          setShowEditSubContracter(false);
          setAction(!action);
        }
      } catch (error) {
        console.log("Error while create sub contractor : ", error);
        message.error(
          error?.response?.data?.message ||
          "Error while updating sub contractor"
        );
      } finally {
        setLoading(false)
        setSubmitting(false);

      }
    },
  });





  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 ">
        <div className="bg-white  rounded-lg shadow-lg w-[900px] h-[600px] overflow-y-auto scrollbar-hidden">
          {loading && (
            <Loader />
          )}
          <h3 className="text-xl font-bold mb-1 text-center bg-blue-950 py-2 text-white">Edit Sub Contractor</h3>
          <form className="p-8" onSubmit={formik.handleSubmit}>

            <h1 className="bg-gray-400 border border-gray-900 flex justify-center text-xl font-semibold mt-4 mb-2 py-2">Personal Details</h1>
            <div className=" flex flex-row items-center justify-center gap-5">
              <div className='w-full'>
                <label className="block mb-1">First Name:</label>
                <input
                  type="text"
                  name="firstName"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.firstName}
                />
                {formik.touched.firstName && formik.errors.firstName && (
                  <p className="text-red-600">{formik.errors.firstName}</p>
                )}

              </div>

              <div className='w-full'>
                <label className="block mb-1">Last Name:</label>
                <input
                  type="text"
                  name="lastName"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.lastName}
                />
                {formik.touched.lastName && formik.errors.lastName && (
                  <p className="text-red-600">{formik.errors.lastName}</p>
                )}
              </div>
            </div>

            <div className='w-full mt-1'>
              <label className="block mb-1">Email:</label>
              <input
                type="text"
                name="emerPhone"
                className="border border-gray-800 bg-gray-100 p-2 w-full"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                disabled
              />

            </div>

            <div className=" flex flex-row items-center justify-center gap-5 mt-1">

              <div className='w-full'>
                <label className="block mb-1">Phone:</label>
                <input
                  type="text"
                  name="phone"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone}
                />
                {formik.touched.phone && formik.errors.phone && (
                  <p className="text-red-600">{formik.errors.phone}</p>
                )}
              </div>

              <div className='w-full'>
                <label className="block mb-1">Emergency Phone:</label>
                <input
                  type="text"
                  name="emerPhone"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.emerPhone || ""}
                />
                {formik.touched.emerPhone && formik.errors.emerPhone && (
                  <p className="text-red-600">{formik.errors.emerPhone}</p>
                )}
              </div>
            </div>


            <div className=" flex flex-row items-center justify-center gap-5">
              <div className="w-full mt-2">
                <label className="block">
                  Status:
                  <select
                    name="status"
                    value={(formik.values.status === 'active') ? 'Active' : 'Inactive'} // Bind to the "status" field
                    onChange={(e) => {
                      const isActive = e.target.value == "Active" ? 'active' : 'inactive'; // Convert "Active" to true, "Inactive" to false
                      formik.setFieldValue('status', isActive); // Update Formik's "status" field with boolean
                    }}
                    className="block w-full p-3 border border-gray-800 bg-white rounded-md mt-1"
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </label>
              </div>

              <div className='w-full mt-2'>
              <div className='w-full'>
                <label className="block mb-1">Company Name:</label>
                <input
                  type="text"
                  name="companyName"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.companyName || ""}
                />
              
              </div>
              </div>
            </div>




            <h1 className="bg-gray-400 border border-gray-900 flex justify-center text-xl font-semibold mt-4 mb-2 py-2">Address Details</h1>

            <div className="flex flex-row justify-center items-center gap-2 mt-2">
              {/* <div className='w-full'>
                <label className="block mb-1">City:</label>
                <input
                  type="text"
                  name="city"
                  className="border p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.city}
                />
              </div> */}



              <div className='w-full'>
                <label className="block mb-1">Street:</label>
                <input
                  type="text"
                  name="street"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.street}
                />
              </div>

              <div className='w-full'>
                <label className="block mb-1">City:</label>
                <input
                  type="text"
                  name="city"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.city}
                />
              </div>
              <div className='w-full'>
                <label className="block mb-1">Prov:</label>
                <input
                  type="text"
                  name="prov"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.prov}
                />
              </div>
            </div>

            <div className=" flex flex-row justify-center items-center gap-3">

              <div className='w-full'>
                <label className="block mt-1 mb-1">Code:</label>
                <input
                  type="text"
                  name="code"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.code}
                />
              </div>

              <div className='w-full'>
                <label className="block mb-1">Home Phone:</label>
                <input
                  type="text"
                  name="homePhone"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.homePhone || ""}

                />
                {formik.touched.homePhone && formik.errors.homePhone && (
                  <p className="text-red-600">{formik.errors.homePhone}</p>
                )}
              </div>

            </div>

            <h1 className="bg-gray-400 border border-gray-900 flex justify-center text-xl font-semibold mt-3 mb-2 py-2">Other Details</h1>
            <div className="flex mt-2 gap-2">
              <div className="w-full">
                <div className="flex items-center gap-2">
                  <label className="block mb-1">Apply HST #:</label>
                  <Checkbox
                    checked={isHstApplied}
                    onChange={(e) => {
                      setIsHstApplied(e.target.checked);
                      formik.setFieldValue('applyHst', e.target.checked);
                      if (!e.target.checked) {
                        formik.setFieldValue('hst', '');
                        formik.setFieldValue('hstRate', '');
                      }
                    }}
                  />
                </div>
                <input
                  type="text"
                  name="hst"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.hst}
                  disabled={!isHstApplied} // Disable input if checkbox is not checked
                />
              </div>

              <div className="w-full">
                <label className="block mb-1">HST Rate:</label>
                <input
                  type="text"
                  name="hstRate"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.hstRate }
                  disabled={!isHstApplied}
                />
              </div>
            </div>

            <div className=" flex flex-row items-center justify-center gap-2 mt-2 ">
              <div className='w-full'>
                <label className="block mb-1">Ins#:</label>
                <input
                  type="text"
                  name="ins"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ins}
                />
              </div>
              <div className='w-full'>
                <label className="block mb-1">Bus:</label>
                <input
                  type="text"
                  name="bus"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.bus}
                />
              </div>
            </div>


            <div className='w-full col-span-3 mt-2'>
              <label className="block mb-1">Comment:</label>
              <textarea
                rows={4}
                name="comment"
                className="border border-gray-800 p-2 w-full"
                placeholder="Edit comments"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.comment || ""}
              />
               {formik.touched.comment && formik.errors.comment && (
                  <p className="text-red-600">{formik.errors.comment}</p>
                )}

            </div>
            <div className="flex justify-center gap-6 mt-6">
              <button onClick={closeEditModal} className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200">
                Cancel
              </button>
              <button type="submit" className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2">
                Update
              </button>

            </div>
          </form>
        </div>
      </div>



    </>
  );
};

export default EditSubContracter;
